<template>
  <div class="lineageChart" ref="mainContainer">

    <Head :index="'1'"></Head>

    <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
      <i class="el-icon-arrow-up"></i>
    </div>

    <div class="chartTop">
      <h1 class="fl">
        个人信息
      </h1>
      <div>
        <el-tag class="tag">{{ familyData.fyzdydz }}</el-tag>
        <el-tag class="tag"> {{ familyData.familyname }}氏族谱</el-tag>
        <el-tag class="tag"> 始祖{{ familyData.ancestorname }}</el-tag>
        <el-tag class="tag">{{ familyData.tangnum }}</el-tag>
        <el-tag class="tag">共记录{{ familyData.maleNum + familyData.femaleNum }}条 (族男{{ familyData.maleNum }}人，族女{{
          familyData.femaleNum }}人，族妻{{ familyData.zuQiNum }}人，族婿{{ familyData.zuXuNum }}人)</el-tag>
        <span style="padding-left:10px" v-if="familyData.canConvert">
          <el-button-group>
            <el-button class="tiny-button" :type="onlyView == 0 ? 'primary' : ''"
              @click="changeauthority(0)">管理员</el-button>
            <el-button class="tiny-button" :type="onlyView == 1 ? 'primary' : ''"
              @click="changeauthority(1)">阅谱员</el-button>
          </el-button-group>
        </span>
      </div>
    </div>
    <div style="height: 100%;" v-show="showType">
      <div class="fl info" v-if="activeName == 'first'">
        <div class="avator" @click="clickfile">
          <img v-if="avatorIma != ''" :src="'https://www.xsdjp.com' + avatorIma" alt="" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </div>
        <input type="file" name="" ref="file" accept="image/jpeg,image/jpg,image/png" @change="changeImage"
          style="display:none" />
        <div class="fr">
          <h2>{{ info.xm }}</h2>
          <p><span>[{{ info.sdlr }} - <!-- {{ info.sr || "未知" }}  --> {{ info.qssdlr }}]</span>&nbsp;
            <span>[{{ info.shixu }}世] </span>
          </p>
          <!-- <p>{{ toChies(info.shixu) }}世 <span v-if="info.sgzt == 0">在世</span><span v-else>已故</span></p>
          <p>
            {{ info.sr || "未知" }} - <span v-if="info.sgzt == 0">至今</span><span v-else>{{ info.qssj }}</span>
          </p> -->
        </div>
        <div class="btnDiv rightBtn">
          <el-button type="text" @click="moreClick()">添加</el-button>
          <el-button type="text" @click="edit(data.id)">编辑</el-button>
        </div>
        <div class="spjj">
          <h3>生平简介</h3>
          <p>
            {{ info.spjj || "暂无简介" }}
          </p>
        </div>
      </div>
      <div class="fr chart" ref="chart" :style="[{ width: activeName == 'first' ? 'calc(100% - 350px)' : '100%' }]">
        <el-tabs v-model="activeName" type="card">
          <!-- @tab-click="handleClick" -->
          <el-tab-pane label="树状结构世系图" name="first">
            <div class="search-input">
              <el-form :model="searchForm" :inline="true" ref="searchForm" @submit.native.prevent="handleSearch">
                <el-form-item prop="name" :rules="[{ required: true, message: '请输入本人姓名', trigger: 'blur' }]"
                  style="margin-bottom:15px">
                  <el-input v-model="searchForm.name" placeholder="请输入本人姓名"
                    style="width: 150px; margin-right: 10px;"></el-input>
                </el-form-item>

                <el-form-item style="margin-bottom:10px">
                  <el-input v-model="searchForm.fatherName" placeholder="请输入父亲姓名"
                    style="width: 150px; margin-right: 15px;"></el-input>
                </el-form-item>

                <el-form-item style="margin-bottom:15px">
                  <el-button type="primary" @click="handleSearch">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div ref="treeContainer" class="tree-container">
              <el-tree class="filter-tree" node-key="id" :data="data" :props="defaultProps"
                :expand-on-click-node="false" default-expand-all ref="tree">
                <span class="custom-tree-node" slot-scope="{ node, data }" @click="NodeClick(data)">
                  <i class="el-icon-s-custom" :style="{ color: data.sex == 0 ? '' : '#ffabd5' }"></i>
                  <span :style="{ 'font-size': '14px', color: data.sex == 1 ? '#ffabd5' : '' }" v-html="data.xm">
                  </span>
                  <span v-if="data.ph != 0">[{{
                    data.sex == 0 ? "" : "女"
                  }}行{{ data.ph == 0 ? "一" : toChies(data.ph) }} ]</span>
                  <span>
                    [{{ data.dc }} - {{ data.jc }}]
                  </span>
                  <span style="color:red"> [{{ data.shixu }}世]</span>
                  <span v-if="familyData.shang == 1 && data.sysx" style="color:#8a2be2">[上源{{ data.sysx }}世]</span>
                  <span @click.stop="delMember(data)" v-if="data.canOperation == true">删除</span>
                </span>
              </el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane label="组织结构世系图" name="second" ref="paneChart" id="paneChart">
            <div id="chart-container"></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="pcinfoDiv" v-if="!showType">
      <div>
        <ul class="fl" ref="infoUrl">
          <li>
            <a href="javascript:;" @click="liType('info')" :class="{ active: type == 'info' }">个人基本信息</a>
          </li>
          <li v-if="$store.state.sgztData">
            <a href="javascript:;" @click="liType('funeral')" :class="{ active: type == 'funeral' }">去世安葬信息</a>
          </li>
          <li v-if="$store.state.hyztData">
            <a href="javascript:;" @click="liType('spouse')" :class="{ active: type == 'spouse' }">配偶生育信息</a>
          </li>
          <li v-if="!$store.state.sgztData">
            <a href="javascript:;" @click="liType('personal')" :class="{ active: type == 'personal' }">联系信息</a>
          </li>
          <li>
            <a href="javascript:;" @click="liType('zlhz')" :class="{ active: type == 'zlhz' }">汇总信息</a>
          </li>
          <li>
            <a href="javascript:;" @click="showType = true">返回世系图</a>
          </li>
        </ul>
        <div class="fl">
          <Child :pType="type" @liType="liType" @submitFun="submitFun" @showFun="showFun"></Child>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="190px" class="operate" :show-close="false">
      <span>
        <div class="name">
          <span class="xm"></span>
          <span class="spousse"></span>
          <p style="top:0">
            {{ memberXm }}
          </p>
          <div class="" :class="{ selector: true, two: znShow, tree: !znShow }">
            <div class="selector open">
              <ul>
                <li v-if="memberData.fatherid == 0" style="transform: rotate(0deg);">
                  <el-button type="primary" @click="addFun(1, 0)">添加父亲</el-button>
                </li>
                <li v-if="memberData.fatherid == 0">
                  <el-button type="primary" @click="getInfo(memberData.id)">查看简介</el-button>
                </li>
                <li>
                  <el-button type="success" @click="edit()" class="edit">编辑</el-button>
                </li>
                <li v-if="memberData.fatherid != 0">
                  <el-button type="primary" @click="addFun(3, 0)" class="brother">添加兄弟</el-button>
                </li>
                <li v-if="memberData.fatherid != 0">
                  <el-button type="primary" @click="addFun(3, 1)" class="sisters">添加姐妹</el-button>
                </li>
                <li v-if="znShow">
                  <el-button type="primary" @click="addFun(2, 0)" class="son">添加儿子</el-button>
                </li>
                <li v-if="znShow">
                  <el-button type="primary" @click="addFun(2, 1)" class="daughter">添加女儿</el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </span>
      <template #footer>
        <span class="dialog-footer"> </span>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="dialogFamily" width="600px">
      <span> </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogMap" width="500" class="map">
    </el-dialog>

    <el-dialog :visible.sync="dialogInfo" width="500" class="map">
      <div>
        {{ infoData.name }}&nbsp;&nbsp;
        <div v-html="infoData.info"></div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="uploadAvator" width="60%" @close="closeFun">
      <div style="width:100%;height:400px">
        <vue-cropper autoCrop :img="imageUrl" ref="cropper" centerBox />
      </div>
      <el-button type="primary" @click="getCropData()" block style="margin:10px 0">上传</el-button>
    </el-dialog>
  </div>
</template>

<script>
import Head from "@/components/header.vue";
import Child from "./info/child.vue";

import rApi from "@/request/api";

import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";

export default {
  data() {
    return {
      searchForm: {
        name: '',        // 本人姓名（必填）
        fatherName: ''   // 父亲姓名（非必填）
      },
      showBackToTop: false, // 控制返回顶部按钮显示隐藏
      scrollTimer: null, // 滚动定时器
      filterText: "",           // el-tree 的 filter 使用
      searchResults: [],        // 搜索结果节点
      highlightNodeId: null,    // 当前高亮节点 id
      showType: true,
      dialogVisible: false,
      dialogFamily: false,
      dialogMap: false,
      uploadAvator: false,
      formKey: "",
      data: [],
      memberData: {},
      memberXm: "",
      familyData: {
        isViewOnly: false,
      },
      info: {},
      avatorIma: '',
      imageUrl: "",
      znShow: true,
      szmz: "",
      activeName: "first",
      echartsInit: null,
      form: {
        mz: "",
        xm: "",
        shixu: "",
        pname: "",
        relation: "",
        sex: 0
      },
      dialogInfo: false,
      infoData: "",
      chartsSrc: "",
      view: null,
      defaultProps: {
        children: "children",
        label: "xm"
      },
      type: "info",
      mtype: "",
      onlyView: 0

    };
  },
  mounted() {
    this.getList();
    this.getmyinfo(localStorage.getItem("fid"), "sz");
    rApi.familyGet(localStorage.getItem("fid")).then((res) => {
      this.familyData = res.data;
      this.$nextTick(() => {
        this.bindScrollEvents();
      });
    });

    // 使用 setTimeout 确保 DOM 完全渲染
    setTimeout(() => {
      this.bindScrollEvents();
    }, 1000);

    // 添加滚动事件监听器
    this.$nextTick(() => {
      const treeContainer = this.$refs.treeContainer;
      if (treeContainer) {
        treeContainer.addEventListener('scroll', this.handleScroll);
        // 同时也监听整个页面的滚动
        window.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  methods: {
    bindScrollEvents() {
      const treeContainer = this.$refs.treeContainer;
      if (treeContainer) {
        treeContainer.addEventListener('scroll', this.handleScroll);
        // 初始化一次，因为可能一开始就有滚动
        this.handleScroll();
      }
      // 同时监听窗口滚动
      window.addEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      const treeContainer = this.$refs.treeContainer;
      if (treeContainer) {
        this.showBackToTop = treeContainer.scrollTop > 100;
      } else {
        // 如果没有树容器，检查页面滚动
        this.showBackToTop = window.pageYOffset > 100 || document.documentElement.scrollTop > 100 || document.body.scrollTop > 100;
      }
    },
    scrollToTop() {
      const treeContainer = this.$refs.treeContainer;
      if (treeContainer) {
        // 平滑滚动到树容器顶部
        this.smoothScrollTo(treeContainer, 0, 500);
      } else {
        // 如果没有树容器，滚动到页面顶部
        this.smoothScrollTo(document.documentElement || document.body, 0, 500);
      }
    },
    smoothScrollTo(element, to, duration) {
      const start = element.scrollTop || window.pageYOffset;
      const change = to - start;
      const startDate = +new Date();

      // 缓动函数
      const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      const animateScroll = () => {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        let val;

        if (element === document.documentElement || element === document.body) {
          // 页面滚动
          val = easeInOutQuad(currentTime, start, change, duration);
          window.scrollTo(0, val);
        } else {
          // 元素滚动
          element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
        }

        if (currentTime < duration) {
          this.scrollTimer = requestAnimationFrame(animateScroll);
        } else {
          if (element === document.documentElement || element === document.body) {
            window.scrollTo(0, to);
          } else {
            element.scrollTop = to;
          }
        }
      };

      animateScroll();
    },
    handleSearch() {
      this.$refs.searchForm.validate(valid => {
        if (!valid) {
          this.$message.error('请输入本人姓名！');
          return;
        }
        this.resetSearchHighlight();

        const treeContainer = this.$refs.treeContainer;
        if (treeContainer) {
          treeContainer.scrollTop = 0;
        }

        const { name, fatherName } = this.searchForm;

        // 第一步：根据姓名筛选所有匹配节点
        const matchedNodes = this.findAllNodesByName(this.data, name);

        if (matchedNodes.length === 0) {
          this.$message.warning('未找到匹配成员');
          this.resetSearchHighlight();
          return;
        }

        let finalNodes = matchedNodes;

        // 如果有输入父亲姓名，则进一步筛选
        if (fatherName) {
          finalNodes = matchedNodes.filter(node => {
            const parentNode = this.findParentNode(this.data, node.id);
            return parentNode && parentNode.xm.includes(fatherName);
          });

          if (finalNodes.length === 0) {
            this.$message.warning('未找到匹配的父亲关系，请检查父亲姓名');
            this.resetSearchHighlight();
            return;
          }
        } else if (matchedNodes.length > 1) {
          // 多个同名，但未输入父亲姓名
          this.$alert('发现多个同名成员，请输入父亲姓名以进一步筛选', '提示', {
            confirmButtonText: '确定',
            type: 'info'
          });
          this.resetSearchHighlight();
          return;
        }

        // 成功找到唯一节点
        this.searchResults = finalNodes;
        this.highlightNodeId = finalNodes[0].id;

        this.$nextTick(() => {
          const node = this.$refs.tree.getNode(finalNodes[0].id);
          if (node) {
            // 高亮并滚动到节点
            this.$refs.tree.setCurrentKey(finalNodes[0].id);
            this.scrollToTreeNode(node);
          }
        });

        this.$message.success(`找到 ${finalNodes.length} 个结果`);
      });
    },
    findAllNodesByName(data, name) {
      const result = [];
      const traverse = (nodes) => {
        for (let node of nodes) {
          if (node.xm.includes(name)) {
            result.push(node);
          }
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
        }
      };
      traverse(data);
      return result;
    },
    findParentNode(data, childId, parent = null) {
      for (let node of data) {
        if (node.id === childId) {
          return parent;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findParentNode(node.children, childId, node);
          if (found) return found;
        }
      }
      return null;
    },
    scrollToTreeNode(treeNode) {
      this.$nextTick(() => {
        // 1. 使用 setCurrentKey 高亮节点
        this.$refs.tree.setCurrentKey(treeNode.key);

        const treeRef = this.$refs.tree;
        const nodeKey = treeNode.key;

        // 2. 尝试滚动到节点
        const treeContainer = this.$refs.treeContainer;
        if (!treeContainer) {
          console.error('el-tree 容器不存在');
          return;
        }

        // 查找包含对应 node-key 的节点
        const selectedNodeEl = treeContainer.querySelector('.is-current'); // Element UI 为当前节点添加的类
        // 获取容器和节点的尺寸信息
        const containerRect = treeContainer.getBoundingClientRect();
        const nodeRect = selectedNodeEl.getBoundingClientRect();

        // 计算滚动位置，使节点在视窗顶部附近显示
        const containerTop = treeContainer.scrollTop;
        const nodeTop = selectedNodeEl.offsetTop;
        const offsetTop = 100; // 留出100px的顶部空间

        // 计算滚动位置
        const scrollTop = nodeTop - containerTop - offsetTop;

        // 平滑滚动到计算出的位置
        treeContainer.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });

        // 为了更明显的高亮效果，可以在滚动后添加一个短暂的背景色
        selectedNodeEl.style.backgroundColor = '#f0f9eb'; // 一个浅绿色背景
        setTimeout(() => {
          selectedNodeEl.style.backgroundColor = '';
        }, 2000); // 2秒后恢复
      });
    },
    resetSearchHighlight() {
      this.searchResults = [];
      this.highlightNodeId = null;
      this.$refs.tree.setCurrentKey(null);
    },
    changeauthority(flag) {
      console.log(flag)
      // this.familyData.isViewOnly = flag
      this.onlyView = flag
      this.getList();
      // rApi.changeauthority({ "fid": localStorage.getItem("fid"), "type": flag == true ? "0" : "1" }).then((res) => {
      //   this.getList();
      // });

    },
    submitFun(data) {
      this.showType = true;
      if (this.mtype == "Add") {
        this.familyData.num = this.familyData.num + 1;
        if (this.form.relation == 1) {
          data.children = [this.data];
          this.data = data;
        } else if (this.form.relation == 2) {
          this.childrenNode(this.data, data);
        } else if (this.form.relation == 3) {
          this.addBrotherNode(this.data, data);
        }
      } else {
        this.editNode(this.data, data);
        this.$forceUpdate();
      }
    },
    showFun(data) {
      this.showType = data;
    },
    editNode(treeData, data) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === Number(data.id)) {
          treeData[i] = data;
          break;
        }
        if (treeData[i].children && treeData[i].children.length > 0) {
          this.editNode(treeData[i].children, data);
        }
      }
      return treeData;
    },

    childrenNode(treeData, data) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === Number(data.onceid)) {
          treeData[i].children.push(data);
          break;
        }
        if (treeData[i].children && treeData[i].children.length > 0) {
          this.childrenNode(treeData[i].children, data);
        }
      }
      return treeData;
    },
    addBrotherNode(treeData, data) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === Number(data.onceid)) {
          treeData.push(data);
          break;
        }
        if (treeData[i].children && treeData[i].children.length > 0) {
          this.addBrotherNode(treeData[i].children, data);
        }
      }
      return treeData;
    },
    getInfo(id) {
      rApi.getInfo(this.$qs.stringify({ fid: localStorage.getItem("fid"), mid: id, num: 1 })).then((res) => {
        this.infoData = res.data[0];
        this.dialogInfo = true;
      });
    },
    append(data) {
      this.getmyinfo(data.id);
    },
    getmyinfo(val, type) {
      rApi.memberGet(val).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          if (this.info.avator && this.info.avator.length != 0) {
            this.avatorIma = this.info.avator[0].url
          } else {
            this.avatorIma = ''
          }
          // console.log(this.info.avator,'----avator')

          this.form.mz = res.data.mz;
          this.$store.dispatch("getActionsData", { key: "mid", val: res.data.id });
          if (type == "sz") {
            this.szmz = res.data.mz;
          }
          this.getData(res.data.id)
        }
      });
    },
    getData(id) {
      rApi.memberGetinfo(this.$qs.stringify({ mid: id, num: 1 })).then((res) => {
        if (res.code == 0) {
          console.log(res.datas, '----data')
        }
      });
    },
    getCropData() {
      this.$refs.cropper.getCropData((data) => {
        rApi.uploadAvator(
          this.$qs.stringify({
            fid: localStorage.getItem("fid"),
            mid: this.info.id,
            img: data
          })
        ).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "上传成功",
              type: "success"
            });
            this.uploadAvator = false;
            this.avatorIma = res.data.url
            // this.getmyinfo();
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      });
    },
    clickfile() {
      this.$refs.file.click();
    },
    changeImage(e) {
      var file = e.target.files[0];
      var reader = new FileReader();
      var that = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        that.imageUrl = this.result;
        that.uploadAvator = true;
      };
    },
    closeFun() {
      this.$refs.file.value = "";
    },
    tabShowFun(val) {
      if (val == 0) {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "数据获取中，请稍后……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      rApi.memberListtree(localStorage.getItem("fid"),this.onlyView).then((res) => {
        loading.close()
        if (res.code == 0) {
          this.data = res.data;
          this.form.xm = res.data[0].xm.split("")[0];
          this.form.mz = res.data[0].mz;
          sessionStorage.setItem("memberId", res.data[0].id);
          this.getmyinfo(res.data[0].id);
          // this.echartsFun();
          function ph(val) {
            var phData = [{
              key: '独',
              val: 0
            },
            {
              key: '长',
              val: 1
            },
            {
              key: '次',
              val: 2
            },
            {
              key: '三',
              val: 3
            },
            {
              key: '四',
              val: 4
            },
            {
              key: '五',
              val: 5
            },
            {
              key: '六',
              val: 6
            },
            {
              key: '七',
              val: 7
            },
            {
              key: '八',
              val: 8
            },
            {
              key: '九',
              val: 9
            },
            {
              key: '十',
              val: 10
            },
            {
              key: '十一',
              val: 11
            },
            {
              key: '十二',
              val: 12
            },
            {
              key: '十三',
              val: 13
            },
            {
              key: '十四',
              val: 14
            },
            {
              key: '十五',
              val: 15
            },
            ];
            let ph = "";
            for (let i = 0; i < phData.length; i++) {
              if (val == phData[i].val) {
                ph = phData[i].key;
              }
            }
            return ph;
          };

          function toChies(val) {
            // return this.$utils.toChies(val);
            let chin = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            if (val <= 10) {
              return chin[val - 1];
            } else if (val <= 99) {
              if (val < 20) {
                return "十" + chin[(val % 10) - 1];
              } else if (val % 10 === 0) {
                return chin[Math.floor(val / 10) - 1] + "十";
              } else {
                return chin[Math.floor(val / 10) - 1] + "十" + chin[(val % 10) - 1];
              }
            }
          }
          var nodeTemplate = function (data) {
            if (data.sex == 0) {
              if (data.sgzt == 1) {
                return `
                  <div class="orgtitle male titledead"><span class="circle-text">${ph(data.ph)}</span>${data.xm}</div>
                  <div class="orgcontent male contentdead"><div class="csqs">${data.dc} - ${data.jc}</div><div class="shixu">${toChies(data.shixu)}世</div></div>
                `;
              } else {
                return `
                  <div class="orgtitle male"><span class="circle-text">${ph(data.ph)}</span>${data.xm}</div>
                  <div class="orgcontent male"><div class="csqs">${data.dc} - ${data.jc}</div><div class="shixu">${toChies(data.shixu)}世</div></div>
                `;
              }
            } else {
              if (data.sgzt == 1) {
                return `
                  <div class="orgtitle female titledead"><span class="circle-text">${ph(data.ph)}</span>${data.xm}</div>
                  <div class="orgcontent female contentdead"><div class="csqs">${data.dc} - ${data.jc}</div><div class="shixu">${toChies(data.shixu)}世</div></div>
                `;
              } else {
                return `
                  <div class="orgtitle female"><span class="circle-text">${ph(data.ph)}</span>${data.xm}</div>
                  <div class="orgcontent female"><div class="csqs">${data.dc} - ${data.jc}</div><div class="shixu">${toChies(data.shixu)}世</div></div>
                `;
              }
            }
          };
          const container = $('#chart-container');
          container.html("")
          this.echartsInit = container.orgchart({
            'data': res.data[0],
            'nodeTemplate': nodeTemplate,
            'exportButton': true,
            'exportFilename': 'family-orgchart'
          });
          // $('.orgchart').addClass('noncollapsable');
        }
      });

    },
    moreClick() {
      this.NodeClick(this.data[0])
    },
    NodeClick(data) {
      this.getmyinfo(data.id);
      this.memberXm = data.xm.replace(/<[^>]*>|/g, "");
      this.memberData = data;
      sessionStorage.setItem("memberId", data.id);
      this.form.shixu = data.shixu;
      var pxm = this.parentName([this.data], data.id);
      this.$store.dispatch("getActionsData", { key: "pxm", val: pxm[pxm.length - 2] });
      if(data.canOperation === true){
        console.log(data)
        this.dialogVisible = true;
        this.znShow = data.sex == 0 ? true : false;
      }else{
        this.getInfo(data.id)
      }
    },
    parentName(arr1, id) {
      var temp = [];
      var forFn = function (arr, id) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.id === id) {
            forFn(arr1, item.fatherid);
            temp.push(item.xm);
            break;
          } else {
            if (item.children) {
              forFn(item.children, id);
            }
          }
        }
      };

      forFn(arr1, id);
      return temp;
    },
    parentId(arr1, id) {
      var temp = [];
      var forFn = function (arr, id) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.id === id) {
            forFn(arr1, item.fatherid);
            temp.push(item.id);
            break;
          } else {
            if (item.children) {
              forFn(item.children, id);
            }
          }
        }
      };
      forFn(arr1, id);
      return temp;
    },

    spouseOpen() {
      this.$router.push("/spouse");
    },
    addFun(val, sex) {
      this.form.relation = val;
      this.form.sex = sex;
      sessionStorage.setItem("memberType", "Add");
      this.mtype = "Add";
      if (val == 3) {
        this.form.pname = this.info.fqxm;
      } else {
        this.form.pname = this.info.xm;
      }
      sessionStorage.setItem("form", this.$qs.stringify(this.form));
      // this.$router.push("/infoMember");
      this.showType = false;
      this.dialogVisible = false;
      this.liType("info");
    },
    add() {
      this.memberData = this.info;
      this.dialogVisible = true;
      this.getmyinfo(0);
      this.znShow = this.info.sex == 0 ? true : false;
      this.form.shixu = this.info.ph;
      this.liType("info");
    },
    edit() {
      this.$store.dispatch("getActionsData", { key: "relation", val: "" });
      sessionStorage.setItem("memberType", "Edit");
      this.mtype = "Edit";
      this.showType = false;
      this.dialogVisible = false;
      this.liType("info");
    },
    delMember(data) {
      this.$alert("确定删除" + data.xm, "删除人员", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            rApi.memberDel(data.id).then((res) => {
              if (res.code == 0) {
                this.familyData.num = this.familyData.num - 1;
                this.delNode(this.data, data);
                this.$message({
                  type: "success",
                  message: "删除成功"
                });
              }
            });
          }
        }
      });
    },
    delNode(treeData, data) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === Number(data.id)) {
          treeData.splice(i, 1);
          break;
        }
        if (treeData[i].children && treeData[i].children.length > 0) {
          this.delNode(treeData[i].children, data);
        }
      }
      return treeData;
    },
    liType(val) {
      this.type = val;
    }
  },
  components: {
    Head,
    Child
    // orgtree
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  destroyed() {
    if (this.view) {
      this.view.remove();
    }

    if (this.scrollTimer) {
      cancelAnimationFrame(this.scrollTimer);
    }

    // 移除事件监听器
    const treeContainer = this.$refs.treeContainer;
    if (treeContainer) {
      treeContainer.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('scroll', this.handleScroll);

    if (this.scrollTimer) {
      cancelAnimationFrame(this.scrollTimer);
    }
  },
  computed: {
    ph(val) {
      return function (val) {
        let ph = "";
        for (let i = 0; i < this.$store.state.phData.length; i++) {
          if (val == this.$store.state.phData[i].val) {
            ph = this.$store.state.phData[i].key;
          }
        }
        return ph;
      };
    },
    toChies(val) {
      return function (val) {
        return this.$utils.toChies(val);
      };
    }
  }
  //that.view.style.display = 'none'
};
</script>

<style lang="less" scoped>
.lineageChart {
  overflow: hidden;
  height: 100%;
  position: relative;

  .chartTop {
    height: 55px;
    line-height: 55px;

    h1 {
      width: 350px;
      font-size: 20px;
      color: #fff;
    }

    >div {
      font-size: 16px;
    }
  }

  .info {
    width: 350px;
    padding: 10px 20px;
    box-sizing: border-box;

    .avator {
      height: 120px;
      width: 88px;
      border: 1px dashed #d9d9d9;
      line-height: 120px;
      text-align: center;
      cursor: pointer;
      display: inline-block;

      img {
        width: 90%;
        height: 90%;
        vertical-align: middle;
      }
    }

    h2,
    p {
      width: 220px;
      text-align: center;
    }

    h2 {
      font-size: 18px;
    }

    p {
      color: #999;
      margin-top: 10px;
    }

    .btnDiv {

      // display: flex;
      // justify-content: space-evenly;
      position: absolute;
      top: 180px;
      left: 180px;
    }

    .spjj {
      p {
        text-align: left;
      }
    }
  }

  .chartImg {
    // position: absolute;
    // left: 360px;
    color: #409eff;
    font-size: 14px;
  }

  .chart {
    width: calc(100% - 350px);
    height: calc(100% - 115px);
    // overflow: auto;
    text-align: center;

    >div {
      overflow: hidden;
      height: 100%;
    }

    .org-tree-container {
      background-color: #f2eee4;
    }

    .el-tabs {
      /deep/ .el-tabs__header {
        position: absolute;
        top: 70px;
        left: 15px;
      }

      /deep/ .el-tabs__content {
        width: 100%;
        height: calc(100% - 10px);
      }

      /deep/ .el-tab-pane {
        height: 100%;
        overflow: scroll;

        .el-input {
          height: 40px;
        }

        .search-input {
          text-align: left;
        }
      }
    }
  }

  .tree-container {
    height: calc(100% - 120px);
    overflow-y: auto;
  }

  //去掉最上级的before  after 即是去电最上层的连接线
  /deep/ .el-tree>div {
    &::before {
      display: none;
    }

    &::after {
      display: none;
    }
  }

  /deep/ .tree {
    .el-tree-node {
      position: relative;

      .el-tree-node__children {
        padding-left: 16px;
      }

      .el-tree-node__children .el-tree-node:before {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
      }
    }

    .el-tree-node :last-child:before {
      height: 38px;
    }

    >.el-tree-node:before {
      border-left: none;
    }

    >.el-tree-node:after {
      border-top: none;
    }

    .el-tree-node:after {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }

    .el-tree-node__expand-icon.is-leaf {
      display: none;
    }

    .el-tree-node:before {
      border-left: 1px dashed #dddddd;
      bottom: 0px;
      height: 100%;
      top: -26px;
      width: 1px;
    }

    .el-tree-node:after {
      border-top: 1px dashed #dddddd;
      height: 20px;
      top: 12px;
      width: 24px;
    }

    .custom-tree-node {
      padding-left: 10px;
    }
  }
}

.pcinfoDiv {
  background: #f1f1f4;
  height: 100%;
  width: 100%;

  >div {
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    padding-top: 15px;
    overflow: hidden;

    >ul {
      width: 120px;
      background: #fff;

      li {
        height: 38px;
        line-height: 38px;
        text-align: center;
      }

      li .active {
        display: block;
        background: #da5660;
        color: #fff;
      }
    }

    >div {
      margin-left: 20px;
      background: #fff;
      width: 1060px;
      height: calc(100% - 120px);
      overflow: auto;

      .nav {
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
      }

      .con {
        padding-left: 80px;
        padding-top: 20px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 10px;

    .el-form-item__label {
      color: #000;
    }

    .el-input__inner,
    .el-textarea__inner {
      border-color: #000;
    }
  }
}

/deep/ .is-active {
  /* 添加选中选项卡的样式 */
  background-color: #008a00;
  color: #ffffff !important;
  font-weight: bold;
}

.tag {
  font-size: 14px;
  background-color: #ffcc66;
  color: #444444;
  font-weight: bold;
}


/* 返回顶部按钮样式 */
.back-to-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 50px;
  height: 50px;
  background-color: #409EFF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  opacity: 1;
  visibility: visible;
}



.back-to-top:hover {
  background-color: #66b1ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
}

.tiny-button {
  /* 减小内边距 */
  padding: 4px 8px !important;
  /* 减小字体 */
  font-size: 14px !important;
  /* 可选：减小圆角 */
  border-radius: 2px !important;
  /* 可选：减小高度 */
  min-height: 28px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/lineageChart.vue